// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ajIL","textarea":"styles_textarea__1H_zf"};